import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
export function WhoIsForSection() {
  return <section className="w-full bg-navy-900" data-id="element-350">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-351">
        <AnimatedSection data-id="element-352">
          <AnimatedItem data-id="element-353">
            <div className="flex items-center gap-3 mb-4" data-id="element-354">
              <div className="h-px flex-1 max-w-[60px] bg-gold-500/40" data-id="element-355" />
              <span className="text-gold-400 text-xs font-body font-semibold tracking-[0.2em] uppercase" data-id="element-356">
                ¿Es Para Ti?
              </span>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-357">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight mb-12" data-id="element-358">
              Descubre si el Plan Retiro es{' '}
              <span className="text-gold-400" data-id="element-359">para ti</span>
            </h2>
          </AnimatedItem>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-360">
            {/* For */}
            <AnimatedItem data-id="element-361">
              <div className="p-6 md:p-8 rounded-2xl bg-navy-800/80 border border-emerald-500/15 h-full" data-id="element-362">
                <h3 className="font-display text-xl font-bold text-emerald-400 mb-6" data-id="element-363">
                  ✓ Esto es para ti si…
                </h3>
                <ul className="space-y-4" data-id="element-364">
                  <li className="flex items-start gap-3" data-id="element-365">
                    <CheckCircleIcon className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-366" />
                    <span className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-367">
                      Tienes entre 25 y 50 años y sientes que vas tarde con tus
                      ahorros para el retiro.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-368">
                    <CheckCircleIcon className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-369" />
                    <span className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-370">
                      Eres hispano en USA o LatAm y buscas diversificar tus
                      ingresos en dólares.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-371">
                    <CheckCircleIcon className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-372" />
                    <span className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-373">
                      Eres empleado o profesional que no tiene tiempo de estar
                      pegado a una pantalla analizando gráficas.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-374">
                    <CheckCircleIcon className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-375" />
                    <span className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-376">
                      Eres inversionista conservador que prioriza la seguridad y
                      el flujo mensual sobre la especulación.
                    </span>
                  </li>
                </ul>
              </div>
            </AnimatedItem>

            {/* Not for */}
            <AnimatedItem data-id="element-377">
              <div className="p-6 md:p-8 rounded-2xl bg-navy-800/80 border border-red-500/15 h-full" data-id="element-378">
                <h3 className="font-display text-xl font-bold text-red-400 mb-6" data-id="element-379">
                  ✗ Esto NO es para ti si…
                </h3>
                <ul className="space-y-4" data-id="element-380">
                  <li className="flex items-start gap-3" data-id="element-381">
                    <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-382" />
                    <span className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-383">
                      Buscas "hacerte rico mañana" sin invertir capital.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-384">
                    <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-385" />
                    <span className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-386">
                      No estás dispuesto a dedicar 30 minutos a la semana para
                      gestionar tu dinero.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-387">
                    <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-388" />
                    <span className="text-slate-300 font-body text-sm leading-relaxed" data-id="element-389">
                      Buscas señales de apuestas o esquemas piramidales.
                    </span>
                  </li>
                </ul>
              </div>
            </AnimatedItem>
          </div>
        </AnimatedSection>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-390" />
    </section>;
}